import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { useBreadcrumb } from "hooks/useBreadcrumb";
import { useTranslation } from "react-i18next";
import { Tab } from "@headlessui/react";
import { useState } from "react";

import SearchByPolicyPanel from "./SearchByPolicyPanel";
import SearchByDocumentPanel from "./SearchByDocumentPanel";

export default function Forms() {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  /// search by policy useState
  const [selectedPolicyId, setSelectedPolicyId] = useState("all");
  const [selectedCompany, setSelectedCompany] = useState("all");
  const [selectedState, setSelectedState] = useState("all");
  const [selectedCatagory, setSelectedCatagory] = useState("all");
  const [selectedProduct, setSelectedProduct] = useState("all");
  const [searchByKeyWords, setSearchByKeyWords] = useState([]);
  const [selectedDocumentCatagory, setSelectedDocumentCatagory] =
    useState("all");
  const [searchByDocumentKeyWords, setSearchByDocumentKeyWords] = useState([]);
  const [isSelectedByPolicyClearClicked, setIsSelectedByPolicyClearClicked] =
    useState(false);
  const [
    isSelectedByDocumentClearClicked,
    setIsSelectedByDocumentClearClicked,
  ] = useState(false);
  ///////////////////////////////////////////////////////////////////////

  const onClear = () => {
    if (selectedTabIndex === 0) {
      setIsSelectedByPolicyClearClicked(!isSelectedByPolicyClearClicked);
      setSelectedPolicyId({ value: "all", displayAs: "Select Contract" });
      setSelectedCatagory("all");
      setSearchByKeyWords([]);
    } else {
      setIsSelectedByDocumentClearClicked(!isSelectedByDocumentClearClicked);
      setSelectedCompany("all");
      setSelectedState("all");
      setSelectedProduct("all");
      setSelectedDocumentCatagory("all");
      setSearchByDocumentKeyWords([]);
    }
  };
  //////////////////////////

  useBreadcrumb([
    { name: "Home", url: "/dashboard" },
    { name: "Services and Claims", url: "/services-claims" },
    { name: "Forms", url: "#" },
  ]);

  useEffect(() => {
    const oldPolicy = searchParams.get("oldPolicy");
    const keyword = searchParams.get("keyword");

    if (oldPolicy) {
      setSelectedPolicyId({ value: oldPolicy });
    }
    if (keyword) {
      setSearchByKeyWords([keyword]);
    }
  }, [searchParams]);

  return (
    <>
      <div className="container mb-8">
        <h1>{t("Forms-title")}</h1>
        <p>{t("Forms-subtitle")}</p>
      </div>

      <div className="container ui-component-spacing">
        <Tab.Group
          selectedIndex={selectedTabIndex}
          onChange={setSelectedTabIndex}
        >
          <div className="flex-grow px-2 md:px-4 rounded-b-none bg-white rounded-t-lg shadow-[2px_2px_4px_0_rgba(0,0,0,0.16)]">
            <Tab.List className="flex flex-row whitespace-nowrap justify-between">
              <div>
                <Tab
                  className={`text-sm mx-3 pt-3 pb-2 mb-1 md:text-base md:mx-4 lg:text-lg ${
                    selectedTabIndex === 0 ? "" : "text-ui-blue"
                  }`}
                >
                  {t("AgentForms-search-policy")}
                </Tab>
                <Tab
                  className={`text-sm mx-3 pt-3 pb-2 mb-1 md:text-base md:mx-4 lg:text-lg ${
                    selectedTabIndex === 1 ? "" : "text-ui-blue"
                  }`}
                >
                  {t("AgentForms-search-document")}
                </Tab>
              </div>

              <div className="flex items-center">
                <button
                  className="text-sm md:text-base lg:text-lg ui-btn-hyperlink"
                  onClick={() => onClear()}
                >
                  {t("AgentForms-btn")}
                </button>
              </div>
            </Tab.List>
          </div>
          <Tab.Panels>
            {selectedTabIndex === 0 && (
              <SearchByPolicyPanel
                selectedPolicyId={selectedPolicyId}
                setSelectedPolicyId={setSelectedPolicyId}
                selectedCatagory={selectedCatagory}
                setSelectedCatagory={setSelectedCatagory}
                searchByKeyWords={searchByKeyWords}
                setSearchByKeyWords={setSearchByKeyWords}
                isClearClicked={isSelectedByPolicyClearClicked}
              />
            )}

            {selectedTabIndex === 1 && (
              <SearchByDocumentPanel
                selectedCompany={selectedCompany}
                setSelectedCompany={setSelectedCompany}
                selectedState={selectedState}
                setSelectedState={setSelectedState}
                selectedCatagory={selectedDocumentCatagory}
                setSelectedCatagory={setSelectedDocumentCatagory}
                selectedProduct={selectedProduct}
                setSelectedProduct={setSelectedProduct}
                searchByKeyWords={searchByDocumentKeyWords}
                setSearchByKeyWords={setSearchByDocumentKeyWords}
                isClearClicked={isSelectedByDocumentClearClicked}
              />
            )}
          </Tab.Panels>
        </Tab.Group>
      </div>
    </>
  );
}
